import React from 'react'

import { twMerge } from 'tailwind-merge'

import Spinner from '@/components/common/Spinner'

interface RootProps {
  children: React.ReactNode
}

export const Root: React.FC<RootProps> = ({ children }) => {
  return <div className="w-full">{children}</div>
}

interface HeaderProps {
  children: React.ReactNode
}

export const Header: React.FC<HeaderProps> = ({ children }) => {
  return (
    <div className="sticky top-0 z-10 flex items-center justify-center min-h-[72px] h-[72px] max-h-[72px] bg-white dark:bg-default-dark border-b border-primary-200 dark:border-primary-800 w-full">
      <div className="w-full max-w-3xl px-4 xl:px-0">{children}</div>
    </div>
  )
}

interface ContentProps {
  children: React.ReactNode
}

export const Content: React.FC<ContentProps> = ({ children }) => {
  return (
    <div className="flex justify-center w-full h-[calc(100%-72px)]">
      <div className="w-full max-w-3xl px-4 xl:px-0">{children}</div>
    </div>
  )
}

export const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <Spinner />
    </div>
  )
}

interface NotFoundProps {
  children: React.ReactNode
}

export const NotFound: React.FC<NotFoundProps> = ({ children }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <span className="text-sm font-medium text-primary-500 dark:text-primary-400">
        {children}
      </span>
    </div>
  )
}

interface NotSpecifiedProps {
  className?: string
}

export const NotSpecified: React.FC<NotSpecifiedProps> = ({ className }) => {
  return (
    <span
      className={twMerge(
        'text-sm text-primary-500 dark:text-primary-400',
        className,
      )}
    >
      Not specified
    </span>
  )
}
